import React, { Component } from 'react';
import { NavigateFunction } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import Calendar from 'react-calendar';
import './SelectDateAndTimePage.css';
import { t } from 'i18next';

import { ReactComponent as ArrowRightIcon } from '../../../assets/icons/arrow-right.svg';

// Redux actions - exactly like reference project
import DeleteLeaveActions from '../../../redux/DeleteLeaveRedux';
import UpdateLeaveActions from '../../../redux/UpdateLeaveRedux';
import UpdateMakeActions from '../../../redux/UpdateMakeRedux';
import GetAppointmentTimeslotsActions from '../../../redux/GetAppointmentTimeslotsRedux';
import GetTimeslotsThirtyDayActions from '../../../redux/GetTimeslotsThirtyDayRedux';
import GetAppointmentTimeslotsNewActions from '../../../redux/GetAppointmentTimeslotsNewRedux';
import ConfirmBox from '../../../components/ConfirmBox';

interface SelectDateAndTimePageProps {
  navigate: NavigateFunction;
  // Redux props - exactly like reference project
  currentSettings: any;
  children: any[];
  getAppointmentTimeslotsNewFetching: boolean;
  getAppointmentTimeslotsNewSuccess: boolean;
  getAppointmentTimeslotsNewError: boolean;
  timeslots: any;
  getTimeslotsThirtyDayFetching: boolean;
  getTimeslotsThirtyDaySuccess: boolean;
  getTimeslotsError: boolean;
  timeslotsNew: any;
  getAppointmentTimeslotsFetching: boolean;
  getAppointmentTimeslotsSuccess: boolean;
  getAppointmentTimeslotsError: boolean;
  timeslotsAppointment: any;
  updateLeaveFetching: boolean;
  updateLeaveSuccess: boolean;
  updateLeaveError: boolean;
  updateMakeFetching: boolean;
  updateMakeSuccess: boolean;
  updateMakeError: boolean;
  leavedata: any;
  // Redux actions - exactly like reference project
  getAppointmentTimeslots: (categoryId: number) => void;
  updateLeave: (leave_id: string, leave: any) => void;
  updateMake: (make_id: string, make: any) => void;
  getAppointmentTimeslotsNew: (children_id: string) => void;
  deleteLeave: (leave_id: string) => void;
  getTimeslotsThirtyDay: (leave_id: string, isTherapist: boolean, children_id: string, page?: string) => void;
}

interface SelectDateAndTimePageState {
  // State - exactly like reference project
  selectedChild: number | null;
  categoryId: number | null;
  code: string | null;
  leave_id: string | null;
  isStudent: boolean | null;
  isTherapist: boolean | null;
  make_id: string | null;
  booking: any;
  showSwitchChildMenu: boolean;
  selectingDate: string | null;
  selected: number | null;
  selectedSlotOption: any | null;
  radioButton: number;
  refresh: number;
  confirmBoxPopupBeforeSession: boolean;
}

class SelectDateAndTimePage extends Component<SelectDateAndTimePageProps, SelectDateAndTimePageState> {
  // Properties - exactly like reference project
  showSwitchChildMenu = false;
  defaultProfilePic = '/default-avatar.png'; // Web equivalent

  constructor(props: SelectDateAndTimePageProps) {
    super(props);

    // Logic - exactly like reference project (adapted for web)
    let selectedChild = this.props.currentSettings?.child;
    // Phase 3 - Route params implemented
    let categoryId: number | null = null;
    let code: string | null = null;
    let leave_id: string | null = null;
    let isStudent: boolean | null = null;
    let isTherapist: boolean | null = null;
    
    // Get route parameters from navigation state (equivalent to React Native's getParam)
    if (this.props.navigate && typeof this.props.navigate === 'function') {
      // For web, we need to get params from the current location or state
      // This will be handled in componentDidMount when we implement proper routing
    }

    // Phase 4 - API calls moved to componentDidMount for proper route parameter handling

    this.state = {
      selectedChild: selectedChild?.id || null,
      categoryId: categoryId,
      code: code,
      leave_id: leave_id,
      isStudent: isStudent,
      isTherapist: isTherapist,
      make_id: null,
      booking: {},
      showSwitchChildMenu: false,
      selectingDate: null,
      selected: null,
      selectedSlotOption: null,
      radioButton: 0,
      refresh: 0,
      confirmBoxPopupBeforeSession: false,
    };

    // Phase 4 - Generate dummy data (commented for now)
    // this.generateDummyData();
  }

  componentDidMount() {
    // Logic - exactly like reference project (adapted for web)
    // BackHandler.addEventListener not needed for web
    console.log('SelectDateAndTimePage mounted');
    
    // Extract route parameters and make API calls
    this.extractRouteParamsAndCallAPI();
  }

  extractRouteParamsAndCallAPI() {
    // Extract route parameters from URL or navigation state
    // This is equivalent to React Native's navigation.getParam()
    const urlParams = new URLSearchParams(window.location.search);
    const categoryId = urlParams.get('categoryId') || this.getStateParam('categoryId');
    const code = urlParams.get('code') || this.getStateParam('code');
    const leave_id = urlParams.get('leave_id') || this.getStateParam('leave_id');
    const isStudent = urlParams.get('isStudent') || this.getStateParam('isStudent');
    const isTherapist = urlParams.get('isTherapist') || this.getStateParam('isTherapist');
    const make_id = urlParams.get('make_id') || this.getStateParam('make_id');



    // Update state with route parameters
    this.setState({
      categoryId: categoryId ? parseInt(categoryId) : null,
      code: code,
      leave_id: leave_id,
      isStudent: isStudent === 'true',
      isTherapist: isTherapist === 'true',
      make_id: make_id,
    });

    setTimeout(() => {
      if (code === "book-a-make-up-session" || code === "reschedule-a-make-up-session") {
        this.props.getTimeslotsThirtyDay(
          leave_id || "",
          isTherapist === 'true' || false,
          this.props.currentSettings.child?.salesforce_contact_id || "",
          "1"
        );
      } else if(code === "leave-request") {
        this.props.getAppointmentTimeslotsNew(
          this.props.currentSettings.child?.salesforce_contact_id || ""
        );
      } else if (!(categoryId === 'undefined' || categoryId === 'null' || !categoryId)) { // Safety check: ensure categoryId is valid
        this.props.getAppointmentTimeslots(parseInt(categoryId));
      }
    }, 200);
  }

  getStateParam(paramName: string): string | null {
    // Try to get parameter from navigation state
    // This is a fallback method for web routing
    try {
      const state = window.history.state;
      return state?.usr?.[paramName] || null;
    } catch (e) {
      return null;
    }
  }

  componentWillUnmount() {
    // Logic - exactly like reference project (adapted for web)
    // BackHandler.removeEventListener not needed for web
  }

  // Methods - exactly like reference project
  handleAndroidBackPress = () => {
    this.props.navigate(-1);
    return true;
  };

  back() {
    // Phase 3 - Back logic (implemented)
    if (this.state.code === "leave-request") {
      this.props.deleteLeave(this.props.leavedata?.id);
    }
    this.props.navigate(-1);
  }

  checkOnCharge() {
    // Phase 3 - Charge logic (implemented)
    if (!this.state.selected) {
      this._onNextPress();
    } else {
      this._onNextPress();
    }
  }

  _onNextPress() {
    // Phase 3 - Next button logic (implemented)
    if (this.state.code === "book-a-make-up-session" || this.state.code === "reschedule-a-make-up-session") {
      let make = {
        salesforce_contact_id: this.props.currentSettings.child?.salesforce_contact_id,
        leave_id: String(this.state.leave_id),
        is_no_charge: String(this.state.radioButton),
        timeslot_and_schedule: [
          {
            appointment_timeslot_id: String(this.state.selected),
            option_schedule: "0",
          },
        ],
        option: 1,
      };
      let makeTherapist = {
        salesforce_contact_id: this.props.currentSettings.child?.salesforce_contact_id,
        therapist_leave_id: String(this.state.leave_id),
        is_no_charge: String(this.state.radioButton),
        timeslot_and_schedule: [
          {
            appointment_timeslot_id: String(this.state.selected),
            option_schedule: "0",
          },
        ],
        option: 1,
      };
      console.log("case 1 VerifyMakeUpSessionScheduleScreen", this.state.make_id, make);
      if (this.state.make_id) {
        this.props.updateMake(this.state.make_id, this.state.isTherapist ? makeTherapist : make);
      }

      var isBeforeReschduleMinimumTime = false;

      // 48-hour check: slot must be at least 48 hours from now (local time)
      const selectedDateString = this.state.selectingDate;
      const selectedSlotOption = this.state.selectedSlotOption;
      if (selectedDateString && selectedSlotOption?.time) {
        const now = moment();
        const rawTime = String(selectedSlotOption.time).trim();
        const slotStartTime = rawTime.includes(' - ') ? rawTime.split(' - ')[0].trim() : rawTime;
        const slotStartTimeNormalized = slotStartTime.split(':').slice(0, 2).join(':');
        const selectedSlot = moment(`${selectedDateString} ${slotStartTimeNormalized}`, 'YYYY-MM-DD HH:mm');
        
        const timestampNow = now.unix();
        const MIN_SECONDS_BEFORE_SESSION = 48 * 60 * 60;  // 48 hours in seconds
        const timestampMinBeforeSession = timestampNow + MIN_SECONDS_BEFORE_SESSION;
        const timestampSelectedSlot = selectedSlot.unix();
        isBeforeReschduleMinimumTime = timestampSelectedSlot < timestampMinBeforeSession;
      }
      
      if (isBeforeReschduleMinimumTime) {
        this.setState({ confirmBoxPopupBeforeSession: true });
      } else {
        setTimeout(() => {
          this._moveToVerifyMackupSessionForBookingOrRescheduleMackupSession();
        }, 500);
      }
    } else if (this.state.selected) {
      if (this.state.code === "leave-request") {
        let appointment_timeslot_id = String(this.state.selected);
        let salesforce_contact_id = String(this.props.currentSettings.child?.salesforce_contact_id);
        let leave = {
          appointment_timeslot_id: appointment_timeslot_id,
          salesforce_contact_id: salesforce_contact_id,
        };
        console.log("case 2.1 LeaveRequestScreen", leave);
        this.props.updateLeave(this.props.leavedata?.id, leave);
        if (this.props.updateLeaveSuccess && !this.props.updateLeaveFetching) {
          // Convert state to query string for better web parameter management
          const queryParams = new URLSearchParams({
            categoryId: String(this.state.categoryId || ''),
            timeslotId: String(this.state.selected || ''),
            childId: String(this.state.selectedChild || ''),
            leave_id: String(this.props.leavedata?.id || ''),
            children_id: String(salesforce_contact_id || ''),
          });
          
          this.props.navigate(`/calendar/leave-request?${queryParams.toString()}`);
        }
      } else {
        console.log("case 2.2 AppointmentSummaryScreen");

        const selectedOption =  this.state.booking[this.state.selectingDate || ""].options.map((option: any) => (option.id == this.state.selected) ? option : null);

        console.log("selectedOption", selectedOption);

        this.props.navigate('/calendar/appointment-summary', {
          state: {
            categoryId: this.state.categoryId,
            timeslotId: this.state.selected,
            childId: this.state.selectedChild,
            selectingDate: this.state.selectingDate,
            selectedOption: selectedOption.length > 0 ? selectedOption[0] : null,
          }
        });
      }
    } else {
      alert("Please select a time slot to continue");
    }
  }

  _moveToVerifyMackupSessionForBookingOrRescheduleMackupSession() {
    // Convert state to query string for better web parameter management
    const queryParams = new URLSearchParams({
      code: String(this.state.code || ''),
      categoryId: String(this.state.categoryId || ''),
      timeslotId: String(this.state.selected || ''),
      childId: String(this.state.selectedChild || ''),
      make_id: String(this.state.make_id || ''),
    });
    
    this.props.navigate(`/calendar/verify-make-up-session-schedule?${queryParams.toString()}`);
  }

  _onSwitchChildPress() {
    this.showSwitchChildMenu = !this.showSwitchChildMenu;
    this.forceUpdate();
  }

  _switchChild(item: any) {
    // Phase 3 - Child switching logic (implemented)
    this.setState({
      selectedChild: item.id,
    });
    this._onSwitchChildCancelPress();
    // API calls based on category code
    if (this.state.code === "book-a-make-up-session" || this.state.code === "reschedule-a-make-up-session") {
      this.props.getTimeslotsThirtyDay(
        this.state.leave_id || "",
        this.state.isTherapist || false,
        item.salesforce_contact_id,
        "1"
      );
    } else if (this.state.code === "leave-request") {
      this.props.getAppointmentTimeslotsNew(item.salesforce_contact_id);
    } else {
      this.props.getAppointmentTimeslots(this.state.categoryId || 0);
    }
  }

  _onSwitchChildCancelPress() {
    this._onSwitchChildPress();
  }

  async _onDayPress(day: Date) {
    // Phase 2 - Day selection logic (implemented) - Fixed timezone issue
    let booking = JSON.parse(JSON.stringify(this.state.booking));
    const dateString = moment(day).format('YYYY-MM-DD'); // Use moment to avoid timezone issues
    if (booking[dateString]) {
      booking[dateString].selected = true;
      this.setState({ 
        selectingDate: dateString, 
        selected: null, 
        selectedSlotOption: null,
        booking 
      });
    }
  }

  render() {
    // Logic - exactly like reference project
    let minDate = moment().subtract(31, "days").format("YYYY-MM-DD");
    let maxDate = moment().add(365, "days").format("YYYY-MM-DD");

    let switchChildButton = null;
    if (this.props.children && this.props.children.length > 1) {
      let child = this.props.children.find((obj: any) => {
        return obj.id === this.state.selectedChild;
      });
      switchChildButton = (
        <div className="switch-children-bar">
          <div className="switch-children-bar-container">
            <span className="switch-children-bar-text">{child?.nickname}</span>
            <button
              className="switch-children-bar-button"
              onClick={() => this._onSwitchChildPress()}
            >
              <ArrowRightIcon style={{ transform: 'rotate(90deg)' }} />
            </button>
          </div>
        </div>
      );
    }

    let switchChildMenu = null;
    if (this.showSwitchChildMenu) {
      switchChildMenu = (
        <div className="switch-child-menu-overlay" onClick={() => this._onSwitchChildCancelPress()}>
          <div className="switch-child-menu">
              <h3 className="switch-child-menu-title">
                Select Child
              </h3>
              {this.props.children?.map((item: any, key: number) => {
                return (
                  <button
                    key={item.id}
                    className={`switch-child-menu-item ${item.id === this.state.selectedChild ? 'current' : ''}`}
                    onClick={() => this._switchChild(item)}
                  >
                    <div className="switch-child-menu-item-container">
                      <img
                        className="switch-child-menu-item-profile-pic"
                        src={item.profile_pic ? item.profile_pic.url : this.defaultProfilePic}
                        alt="Profile"
                      />
                      <span className={`switch-child-menu-item-name ${item.id === this.state.selectedChild ? 'current' : ''}`}>
                        {item.nickname}
                      </span>
                    </div>
                  </button>
                );
              })}
              <button
                className="switch-child-menu-cancel"
                onClick={() => this._onSwitchChildCancelPress()}
              >
                Cancel
              </button>
          </div>
        </div>
      );
    }

    return (
      <div className="main-container">
        <div className="select-date-and-time-page">
        {switchChildMenu}
        
        {/* Header - exactly like reference project */}
        <header className="page-header">
          <div className="page-header-inner">
            <div className="header-left">
              <button className="header-button back-button" onClick={() => this.back()}>
                <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.79646 0.204319C6.07989 0.482194 6.07989 0.943465 5.80201 1.2269L2.42862 4.61141H15.2831C15.6777 4.61141 16 4.93374 16 5.33388C16 5.73402 15.6777 6.05635 15.2831 6.05635H2.42862L5.80757 9.44086C6.08545 9.72429 6.07989 10.18 5.80201 10.4634C5.51858 10.7413 5.06843 10.7413 4.78499 10.4579L0.205627 5.84517C0.144495 5.77848 0.0944773 5.70623 0.0555749 5.61731C0.0166725 5.52839 0 5.43391 0 5.33944C0 5.15048 0.0722476 4.97264 0.205627 4.8337L4.78499 0.220992C5.05731 -0.0679974 5.51303 -0.073555 5.79646 0.204319Z" fill="black"></path></svg>
              </button>
              <h1 className="header-title">{String(t?.('select-date-and-time-screen:title') || 'Select Date and Time')}</h1>
            </div>
            <div className="header-right">
              {this.state.selectingDate ? (
                <button className="next-button header-button enabled" onClick={() => this.checkOnCharge()}>
                  <span className="button-text">{String(t?.('select-date-and-time-screen:header.right') || 'Next')}</span>
                </button>
              ) : (
                <button className="next-button header-button disabled" disabled>
                  <span className="button-text">{String(t?.('select-date-and-time-screen:header.right') || 'Next')}</span>
                </button>
              )}
            </div>
          </div>
        </header>

        
        <div className="select-date-and-time-content">
          {switchChildButton}
        {/* Calendar Section - exactly like reference project */}
        <div className="calendar-section">
          {/* Phase 4 - Loading state (implemented) */}
          {this.props.getAppointmentTimeslotsNewFetching || this.props.getTimeslotsThirtyDayFetching || this.props.getAppointmentTimeslotsFetching ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
            </div>
          ) : (
            <div className="calendar-container">
              <Calendar
                onChange={(value) => {
                  if (value instanceof Date) {
                    this._onDayPress(value);
                  }
                }}
                minDate={new Date(minDate)}
                maxDate={new Date(maxDate)}
                className="react-calendar"
                // Phase 4 - Calendar props (implemented) - Fixed timezone issues
                tileDisabled={({ date }) => {
                  const dateString = moment(date).format('YYYY-MM-DD'); // Use moment to avoid timezone issues
                  // Enable dates that have timeslots (options), disable dates without timeslots
                  return !this.state.booking[dateString]?.options || this.state.booking[dateString]?.disabled;
                }}
                tileClassName={({ date }) => {
                  const dateString = moment(date).format('YYYY-MM-DD'); // Use moment to avoid timezone issues
                  const dayData = this.state.booking[dateString];
                  if (!dayData) return '';
                  
                  let className = '';
                  if (dayData.selected) className += ' selected-date ';
                  if (dayData.disabled) className += ' disabled-date ';
                  if (dayData.options && dayData.options.length > 0) className += ' has-timeslots ';
                  
                  return className;
                }}
                tileContent={({ date }) => {
                  const dateString = moment(date).format('YYYY-MM-DD'); // Use moment to avoid timezone issues
                  const dayData = this.state.booking[dateString];
                  
                  if (!dayData || !dayData.options || dayData.options.length === 0) {
                    return null;
                  }
                  
                  return (
                    <div className="calendar-event-dots">
                      {dayData.options.slice(0, 3).map((_: any, index: number) => (
                        <div key={index} className="event-dot" />
                      ))}
                    </div>
                  );
                }}
              />
            </div>
          )}
        </div>

        {/* Available Times Section - exactly like reference project */}
        <div className="available-times-section">
          {/* Phase 4 - Dynamic content (implemented) */}
          {this.props.getAppointmentTimeslotsNewFetching || this.props.getTimeslotsThirtyDayFetching || this.props.getAppointmentTimeslotsFetching ? null : this.state.selectingDate ? (
            this.state.booking.hasOwnProperty(this.state.selectingDate) && this.state.booking[this.state.selectingDate].hasOwnProperty("options") ? (
              <h3 className="available-times-title">
                {moment(this.state.selectingDate).format("Do MMM, YYYY")}
                <span className="ave-time">{"\nAvailable Times"}</span>
              </h3>
            ) : null
          ) : (
            <h3 className="select-a-date">
              {String(t?.('select-date-and-time-screen:message.select-a-date-to-see-available-times') || 'Select a date to see available times')}
            </h3>
          )}
        </div>

        {/* Time Slots Section - exactly like reference project */}
        <div className="time-slots-section">
          {/* Phase 4 - Dynamic time slots (implemented) */}
          {this.props.getAppointmentTimeslotsNewFetching || this.props.getTimeslotsThirtyDayFetching || this.props.getAppointmentTimeslotsFetching ? null : this.state.selectingDate ? (
            this.state.booking.hasOwnProperty(this.state.selectingDate) && this.state.booking[this.state.selectingDate].hasOwnProperty("options") ? (
              <div className="time-slots-list">
                {this.state.booking[this.state.selectingDate].options.map((option: any, key: number) => {
                  return (
                    <div
                      className={`time-slot-item ${this.state.selected === option.id ? 'selected' : ''}`}
                      key={key}
                      onClick={() => {
                        this.setState({
                          selected: option.id,
                          selectedSlotOption: option,
                          radioButton: 0,
                        });
                      }}
                    >
                      <div className="time-text">
                        <span>{option.time}</span>
                      </div>
                      <div className="time-selection">
                        {this.state.selected === option.id ? (
                          <span className="radio-selected"></span>
                        ) : (
                          <span className="radio-unselected"></span>
                        )}
                      </div>
                    </div>
                  );
                })}

                {this.state.code === "book-a-make-up-session" || this.state.code === "reschedule-a-make-up-session" ? 
                <div
                  className={`time-slot-item ${this.state.radioButton == 1 ? 'selected' : ''}`}
                  onClick={() => {
                    this.setState({ radioButton: 1, selected: null })
                  }}
                >
                  <div className="time-text">
                    <span>{String(t?.('select-leavere-quest:no-suitable-time') || 'No suitable time')}</span>
                  </div>
                  <div className="time-selection">
                    {this.state.radioButton == 1 ? (
                      <span className="radio-selected"></span>
                    ) : (
                      <span className="radio-unselected"></span>
                    )}
                  </div>
                </div>
                :<></>}

              </div>
            ) : (
              <div className="no-available-timeslot">
                <div className="no-available-icon">📅</div>
                <p className="no-available-text">No available time slots for this date</p>
              </div>
            )
          ) : null}
        </div>
        </div>
      </div>

      <ConfirmBox
        title={''}
        message={t?.('select-date-and-time-screen:alert.confirm-before-session.message') || 'Sessions booked within the coming 48 hours will not be able to be rescheduled.'}
        confirmAction={() => this.setState({ confirmBoxPopupBeforeSession: false }, this._moveToVerifyMackupSessionForBookingOrRescheduleMackupSession)}
        cancelAction={() => this.setState({ confirmBoxPopupBeforeSession: false })}
        isVisible={this.state.confirmBoxPopupBeforeSession}
        onClose={() => {}}
        confirmText={String(t?.('select-date-and-time-screen:alert.confirm-before-session.continue') || 'Continue')}
        cancelText={String(t?.('common:cancel') || 'Cancel')}
      />

      </div>
    );
  }

  // Phase 4 - getDerivedStateFromProps (implemented)
  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (prevState.props) {
      if (
        !nextProps.getAppointmentTimeslotsNewFetching ||
        !nextProps.getTimeslotsThirtyDayFetching ||
        !nextProps.getAppointmentTimeslotsFetching
      ) {
        if (
          nextProps.getAppointmentTimeslotsNewSuccess &&
          nextProps.getAppointmentTimeslotsNewSuccess !==
            prevState.props.getAppointmentTimeslotsNewSuccess
        ) {
          if (nextProps.timeslots) {
            let booking: any = {};
            for (let i = -90; i < 3900; i++) {
              // Use moment to avoid timezone issues
              const date = moment().add(i, 'days');
              const dateString = date.format('YYYY-MM-DD');
              
              if (!nextProps.timeslots[dateString]) {
                booking[dateString] = { disabled: true, disableTouchEvent: true };
              } else {
                booking[dateString] = {
                  options: nextProps.timeslots[dateString].options,
                  selected: prevState.selectingDate === dateString,
                };
              }
            }

            return {
              booking: booking,
            };
          }
        } else if (
          nextProps.getTimeslotsThirtyDaySuccess &&
          nextProps.getTimeslotsThirtyDaySuccess !==
            prevState.props.getTimeslotsThirtyDaySuccess
        ) {
          if (nextProps.timeslotsNew) {
            let booking: any = {};
            for (let i = -90; i < 3900; i++) {
              // Use moment to avoid timezone issues
              const date = moment().add(i, 'days');
              const dateString = date.format('YYYY-MM-DD');

              if (!nextProps.timeslotsNew[dateString]) {
                booking[dateString] = { disabled: true, disableTouchEvent: true };
              } else {
                booking[dateString] = {
                  options: nextProps.timeslotsNew[dateString].options,
                  selected: prevState.selectingDate === dateString,
                };
              }
            }

            return {
              booking: booking,
            };
          }
        } else if (
          nextProps.getAppointmentTimeslotsSuccess &&
          nextProps.getAppointmentTimeslotsSuccess !==
            prevState.props.getAppointmentTimeslotsSuccess
        ) {
          if (nextProps.timeslotsAppointment) {
            let booking: any = {};
            for (let i = -90; i < 3900; i++) {
              // Use moment to avoid timezone issues
              const date = moment().add(i, 'days');
              const dateString = date.format('YYYY-MM-DD');

              if (!nextProps.timeslotsAppointment[dateString]) {
                booking[dateString] = { disabled: true, disableTouchEvent: true };
              } else {
                booking[dateString] = {
                  options: nextProps.timeslotsAppointment[dateString].options,
                  selected: prevState.selectingDate === dateString,
                };
              }
            }

            return {
              booking: booking,
            };
          }
        }
      }

      if (
        nextProps.getAppointmentTimeslotsNewError &&
        nextProps.getAppointmentTimeslotsNewError !==
          prevState.props.getAppointmentTimeslotsNewError
      ) {
        // Handle error state
      }
    }

    return {
      props: nextProps,
    };
  }
}

// Redux mapping - exactly like reference project
const mapStateToProps = (state: any) => {
  return {
    currentSettings: state.currentSettings,
    children: state.getChildren.children,
    getAppointmentTimeslotsNewFetching: state.getAppointmentTimeslotsNew.fetching,
    getAppointmentTimeslotsNewSuccess: state.getAppointmentTimeslotsNew.success,
    getAppointmentTimeslotsNewError: state.getAppointmentTimeslotsNew.error,
    timeslots: state.getAppointmentTimeslotsNew.timeslots,
    getTimeslotsThirtyDayFetching: state.getTimeslotsThirtyDay.fetching,
    getTimeslotsThirtyDaySuccess: state.getTimeslotsThirtyDay.success,
    getTimeslotsError: state.getTimeslotsThirtyDay.error,
    timeslotsNew: state.getTimeslotsThirtyDay.timeslots,
    getAppointmentTimeslotsFetching: state.getAppointmentTimeslots.fetching,
    getAppointmentTimeslotsSuccess: state.getAppointmentTimeslots.success,
    getAppointmentTimeslotsError: state.getAppointmentTimeslots.error,
    timeslotsAppointment: state.getAppointmentTimeslots.timeslots,
    updateLeaveFetching: state.updateLeave.fetching,
    updateLeaveSuccess: state.updateLeave.success,
    updateLeaveError: state.updateLeave.error,
    updateMakeFetching: state.updateMake.fetching,
    updateMakeSuccess: state.updateMake.success,
    updateMakeError: state.updateMake.error,
    leavedata: state.leave.leavedata,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getAppointmentTimeslots: (categoryId: number) =>
      dispatch(GetAppointmentTimeslotsActions.getAppointmentTimeslotsRequest(categoryId)),
    updateLeave: (leave_id: string, leave: any) =>
      dispatch(UpdateLeaveActions.updateLeaveRequest(leave_id, leave)),
    updateMake: (make_id: string, make: any) =>
      dispatch(UpdateMakeActions.updateMakeRequest(make_id, make)),
    getAppointmentTimeslotsNew: (children_id: string) =>
      dispatch(GetAppointmentTimeslotsNewActions.getAppointmentTimeslotsNewRequest(children_id)),
    deleteLeave: (leave_id: string) =>
      dispatch(DeleteLeaveActions.deleteLeaveRequest(leave_id)),
    getTimeslotsThirtyDay: (leave_id: string, isTherapist: boolean, children_id: string, page?: string) =>
      dispatch(GetTimeslotsThirtyDayActions.getTimeslotsThirtyDayRequest(leave_id, children_id, isTherapist, page || "1")),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectDateAndTimePage);
